<template>
  <div class="TestKitInfoResult">

    <div class="TestKitInfoResult-title">
      本次信息上传仅用于大肠癌筛查活动使用，我们将保护每位
      用户隐私，请放心上传。
    </div>

    <div class="TestKitInfoResult-content">

      <div class="TestKitInfoResult-content-img">
        <img src="../../assets/TestKit/success.png" alt="">
        <p>信息提交成功</p>
      </div>

      <div class="TestKitInfoResult-content-box">
        <ul class="TestKitInfoResult-content-box-list">
          <li>
            <p>姓名</p>
            <p>{{ info.name }}</p>
          </li>
          <li>
            <p>受检人手机号</p>
            <p>{{ info.phoneNoOne }}</p>
          </li>
          <li>
            <p>身份证号</p>
            <p>{{ info.idCardNo }}</p>
          </li>
          <li>
            <p>试剂盒编号</p>
            <p>{{ info.reagentNo }}</p>
          </li>
        </ul>
      </div>

      <p class="TestKitInfoResult-content-footer">
<!--        请将此页面出示给工作人员，领取检测盒<br/>-->
        如果您不在活动现场，请截图保存。<br/>
        试剂盒检测结果和肠道风险自测结果稍后开放查询
      </p>

    </div>

  </div>
</template>

<script>
export default {
  name: "TestKitInfoResult",
  data() {
    return {
      info: this.$route.query.info,
    }
  },
  created() {
    document.title= "提交结果";
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
 @import "../../style/TestKit/TestKitInfoResult";
</style>
